// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__vMqoq","blink":"Loader_blink__VHvgk"};